import {Component} from 'react';
import { withRouter } from 'react-router-dom';
import { default as Const } from '../../constants';

class Results extends Component {
    constructor(props) {
        super(props);

        this.resultsBtn = null;

        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        let resultsButton = document.getElementById(Const.RESULTS_BTN_SELECTOR);

        if (resultsButton !== null) {
            resultsButton.onclick = this.onClick;
            this.resultsBtn = resultsButton;
        }
    }

    onClick(event) {
        event.preventDefault();

        if (this.props.onClick) {
            this.props.onClick();
        }

        this.props.history.push('/results');

        return false;
    }

    render() {
        if (this.resultsBtn) {
            this.resultsBtn.style.display = true === this.props.visible ? 'block' : 'none';
        }

        if (this.props.hasNewResults) {
            this.resultsBtn.classList.toggle(Const.RESULTS_BTN_SELECTOR);
        }

        return null;
    }
}
export default withRouter(Results);